export const MOCK_TRUSTED: ReadonlyArray<{ initials: string; name: string }> = [
	{ initials: "EC", name: "Excel Center" },
	{ initials: "UA", name: "UAMS" },
	{ initials: "PP", name: "Peer Power" },
	{ initials: "C2C", name: "Corner to Corner" },
	{ initials: "NMF", name: "National Medical Fellowships" },
	{ initials: "BM", name: "Building Memphis" },
	{ initials: "CA", name: "Code Academy" },
	{ initials: "LF", name: "LaunchForward" },
];
